import React from 'react';
import { kebabCase } from 'lodash';
import { M } from '@dashboard-experience/mastodon';
import { Document as DocumentType } from 'types/document';

type Props = {
  document: DocumentType;
};

const Document = ({ document }: Props) => (
  <M.Link
    href={document.downloadUri}
    target='_blank'
    rel='noopener noreferrer'
    data-testid='story-document-link'
  >
    <M.Button kind='secondary' className={kebabCase(document.contentType)}>
      {document.filename}
    </M.Button>
  </M.Link>
);

export default Document;
